import ApiService from "@/common/api/api.service";

const InfosService = {
    buscarEndereco(cep) {
        return ApiService.get(`Endereco/cep?cep=${cep}`);
    },

    buscarCidades(uf){
        return ApiService.get(`Endereco/municipios?uf=${uf}`);
    },

    //Temas e subtemas das demandas e planejamento estratégico
    buscarTemas() {
        return ApiService.get(`Tema`);
    },

    buscarSubtemas() {
        return ApiService.get(`Subtema`);
    },
};

export default InfosService;